import { isPositiveNumber } from "../../client/src/utils/isPositiveNumber";
import { PricingSheetRow } from "../types";

/**
 * Row contains rental history
 */
export const isRentalHistoryRow = (pricingSheetRow: PricingSheetRow) =>
  isPositiveNumber(pricingSheetRow.rentalDaysDay) ||
  isPositiveNumber(pricingSheetRow.rentalDaysMonth);
